import { render, staticRenderFns } from "./ConfigurazioneMagazzinoMagazziniEditComponent.vue?vue&type=template&id=20e3dec5"
import script from "./ConfigurazioneMagazzinoMagazziniEditComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMagazzinoMagazziniEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports